module.exports = __webpack_public_path__ + "static/media/Gallery-11.025e133f.jpg";